import React, { useState } from "react";
import { Box, IconButton, Typography, useMediaQuery } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { useTheme } from '@mui/material/styles';

const images = [
    { src: "/theme-screenshot/Dracula.png", alt: "Dracula Theme" },
    { src: "/theme-screenshot/Light.png", alt: "Light Theme" },
    { src: "/theme-screenshot/Dark.png", alt: "Dark Theme" },
    { src: "/theme-screenshot/Monokai.png", alt: "Monokai Theme" },
];

const ImageSlider = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const maxIndex = images.length - 1;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex === maxIndex ? 0 : prevIndex + 1));
    };

    const handleBack = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? maxIndex : prevIndex - 1));
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: '24px', gap: '8px' }}>
            <Typography>{images[currentIndex].alt}</Typography>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    width: isMobile ? '100%' : '70%',
                    // flexGrow: 1,
                    // maxWidth: "800px",
                    height: "auto",
                    margin: "auto",
                }}
            >

                {/* Left Navigation Button */}
                <IconButton
                    onClick={handleBack}
                    sx={{
                        position: "absolute",
                        left: 2,
                        color: "white",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.7)" },
                    }}
                >
                    <ArrowBackIos />
                </IconButton>

                {/* Image Display */}
                <img
                    src={images[currentIndex].src}
                    alt={images[currentIndex].alt}
                    style={{
                        width: "100%",
                        //   width: isMobile ? '100%' : '70%',
                        height: "auto",
                        display: "block",
                        objectFit: "contain",
                        borderRadius: "8px",
                    }}
                />

                {/* Right Navigation Button */}
                <IconButton
                    onClick={handleNext}
                    sx={{
                        position: "absolute",
                        right: 2,
                        color: "white",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.7)" },
                    }}
                >
                    <ArrowForwardIos />
                </IconButton>
            </Box>
        </Box>
    );
};

export default ImageSlider;
